import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_NEW_DOCTOR_VISIT_SUMMARY} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const NewDoctorVisitSummary = lazy(() =>
  import('../../../screens/NewDoctorVisitSummary')
    .then(module => ({default: module.NewDoctorVisitSummary})));

const NewDoctorVisitSummaryNavigation = [
  {
    path: ROUTE_NEW_DOCTOR_VISIT_SUMMARY,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <NewDoctorVisitSummary />
      </Suspense>
    ),
  },
];

export default NewDoctorVisitSummaryNavigation;
